<template>
  <Accordion #default="{ isOpen, handleFocus }">
    <AccordionSection
      :path="'D2 Plaza 1 and 2.mp3'"
      :open="isOpen == 0"
      @open="handleFocus(0)"
    >
      <template #title>
        Black Greek Organizations
      </template>
      <template #content>
        <p v-if="captions" class="content">
          Hello and welcome to Dietrick Plaza. Starting in the 1970s, this was a
          site central to Black visibility on Virginia Tech’s campus. In 1973,
          Alpha Phi Alpha Fraternity Inc. became the first Black Greek
          organization at Virginia Tech. While the alphas were the first, they
          were certainly not the last Black fraternity or sorority to come to
          Virginia Tech’s campus. Since 1973, VT has been home to a chapter of
          each of Divine Nine, a group of historically Black Greek letter
          organizations. Each of them helped turn Virginia Tech into home for
          many of their members.
        </p>
        <ImageComponent :image="apa1975AtPark" />
        <p v-if="captions" class="content">
          At predominately white institutions such as Virginia Tech, the
          presence of these Black organizations was vital to the success of many
          Black students. In the 1970s and early 80s, approximately 42% of Black
          students were members of one of these fraternities and sororities.
          When compared to the mere 8% of white students who were involved in
          Greek life, it becomes clear that these organizations offered Black
          students a support network that they could not find on campus.
        </p>
        <ImageComponent :image="bocGreek1990" />
      </template>
    </AccordionSection>
    <AccordionSection
      :path="'D2 Plaza 3.mp3'"
      :open="isOpen == 1"
      @open="handleFocus(1)"
    >
      <template #title> Jan. 1973 - Alpha Phi Alpha Fraternity Inc.</template>
      <template #content>
        <p v-if="captions" class="content">
          On January 29, 1973, the Theta Iota chapter of Alpha Phi Alpha
          Fraternity Inc. became the first Historically Black fraternity at
          Virginia Tech. It was chartered by a group of Black students known as
          the fine nine: Anthony Dennis Crisp, Darrell Anthony Givens, Clarence
          Linwood James Jr., Jerry Nathaniel Johnson, James Kirkpatrick III,
          Lewis Anthony Marshall, Ronald Sinclair Robinson, Warren Carlton
          Rodgers Jr., and James Earl Williams. The organization was devoted to
          the local community, with projects such as blood drives and tutoring
          local high school students. The Theta Iota chapter has helped to
          instil the fraternity motto of Manly Deeds, Scholarship, and Love for
          All Mankind into more than 230 brothers at Virginia Tech.
        </p>
        <Carousel :images="apa" />
      </template>
    </AccordionSection>
    <AccordionSection
      :path="'D2 Plaza 4.mp3'"
      :open="isOpen == 2"
      @open="handleFocus(2)"
    >
      <template #title>
        May 4, 1974 - Alpha Kappa Alpha Sorority Inc.
      </template>
      <template #content>
        <p v-if="captions" class="content">
          On May 4, 1974, Alpha Kappa Alpha Sorority Inc. became the first
          historically black sorority at Virginia Tech. The motto of the Theta
          Phi chapter here at Virginia Tech is Love, Strength, and Blackness
          which reflects their strong conviction for their sisterhood. As a
          social-service organization, AKA helped these women find their own
          identity, have fun, and help others.
        </p>
        <Carousel :images="aka" />
      </template>
    </AccordionSection>

    <AccordionSection
      :path="'D2 Plaza 5.mp3'"
      :open="isOpen == 3"
      @open="handleFocus(3)"
    >
      <template #title>
        April 12, 1975 - Delta Sigma Theta Sorority Inc.
      </template>
      <template #content>
        <p v-if="captions" class="content">
          The Mu Alpha chapter of the Delta Sigma Theta Sorority Inc. was
          founded at Virginia Tech on April 12, 1975. The group was very active
          on campus and in the community. The chapter started a program at
          Blacksburg Library where they read to local elementary school children
          and regularly volunteered at local churches.
        </p>
        <Carousel :images="dst" />
      </template>
    </AccordionSection>

    <AccordionSection
      :path="'D2 Plaza 6.mp3'"
      :open="isOpen == 4"
      @open="handleFocus(4)"
    >
      <template #title>
        April 1977 - Kappa Alpha Psi Fraternity Inc
      </template>
      <template #content>
        <p v-if="captions" class="content">
          Kappa Alpha Psi Fraternity, Inc.: The Theta Psi Chapter was chartered
          at Virginia Tech in April 1977 by Gary Smith, Brian Witcher, Ricky
          Scales, Larry Blunt, Anthony Pope, Michael Price, Jerry Livingston,
          Marcus Evans, Louis Williamson and Archie Watson.
        </p>
        <ImageComponent :image="kap" />
      </template>
    </AccordionSection>

    <AccordionSection
      :path="'D2 Plaza 7.mp3'"
      :open="isOpen == 5"
      @open="handleFocus(5)"
    >
      <template #title>
        September 22, 1979 - Omega Psi Phi Fraternity Inc.
      </template>
      <template #content>
        <p v-if="captions" class="content">
          The Eta Lamda Chapter of Omega Psi Phi Fraternity, Inc., was founded
          on September 22, 1979 by D. K. Brockett, Barry Griffin, Stan Harris,
          Peter Holmes, Rick Monroe, Larry Fallen, Dennis Scott, and Wayne
          Robinson. The organization was devoted to giving back to the community
          and hosted a variety of fundraisers including buffets at local
          churches, essay contests, and clothing drives.
        </p>
        <Carousel :images="opp" />
      </template>
    </AccordionSection>

    <AccordionSection
      :path="'D2 Plaza 8.mp3'"
      :open="isOpen == 6"
      @open="handleFocus(6)"
    >
      <template #title>
        May 1980 - Phi Beta Sigma Fraternity Inc.
      </template>
      <template #content>
        <p v-if="captions" class="content">
          The Mu Nu chapter of Phi Beta Sigma Fraternity, Inc. was chartered at
          Virginia Tech on May 15, 1980 by Chuck Bishop, Bruce Carver, Roger
          Freeman, Kurt Holloway, Kenny Johnson, Tony R. King, and Eric Pankey.
        </p>
        <Carousel :images="pbs" />
      </template>
    </AccordionSection>

    <AccordionSection
      :path="'D2 Plaza 9.mp3'"
      :open="isOpen == 7"
      @open="handleFocus(7)"
    >
      <template #title>
        May 22, 1982 - Zeta Phi Beta Sorority Inc.
      </template>
      <template #content>
        <p v-if="captions" class="content">
          The Upsilon Lambda Chapter of Zeta Phi Beta Sorority was chartered on
          May 22, 1982 by Francine Atkinson, Vivian Johnson Barry, Denise
          Cartwright, Diane Eaves, Lynn Hamilton-Jones, Chrystall Bullock
          McGhree, and Monalisa White. These women strived to uphold the
          sorority’s core principles of Scholarship, Service, Sisterhood, and
          Finer Womanhood.
        </p>
        <Carousel :images="zpb" />
      </template>
    </AccordionSection>

    <AccordionSection
      :path="'D2 Plaza 10.mp3'"
      :open="isOpen == 8"
      @open="handleFocus(8)"
    >
      <template #title>
        April 20, 1985 - Sigma Gamma Rho Sorority Inc.
      </template>
      <template #content>
        <p v-if="captions" class="content">
          On April 20, 1985, the Kappa Psi Chapter of Sigma Gamma Rho Sorority,
          Inc. was chartered on Virginia Tech's campus by Katrina Everette,
          Kathy Smith, Sophia Redd, Jammie Noel, and Pamela Matthews. "Sigma
          Gamma Rho Sorority's aim is to enhance the quality of life within the
          community. Public service, leadership development and education of
          youth are the hallmark of the organization's programs and activities.
        </p>
        <ImageComponent :image="sgr" />
      </template>
    </AccordionSection>

    <AccordionSection
      :path="'D2 Plaza 11.mp3'"
      :open="isOpen == 9"
      @open="handleFocus(9)"
    >
      <template #title> Iota Phi Theta Fraternity Inc. </template>
      <template #content>
        <p v-if="captions" class="content">
          The Eta Xi chapter of Iota Phi Theta Fraternity Inc. was officially
          chartered on March 29, 2007. This marked the first time all “Divine 9“
          NPHC organizations were part of the Virginia Tech community.
        </p>
      </template>
    </AccordionSection>
    <AccordionSection
      :path="'D2 Plaza 12.mp3'"
      :open="isOpen == 10"
      @open="handleFocus(10)"
    >
      <template #title> Stepping </template>
      <template #content>
        <p v-if="captions" class="content">
          Each of these groups would have participated in events right here at
          Dietrick Plaza. One of them was stepping. Developed by Black
          fraternities and sororities, stepping is a form of percussive dance in
          which the participant's entire body is used as an instrument to
          produce complex rhythms and sounds through a mixture of footsteps,
          spoken word, and handclaps. Stepping is a tradition at the Heart of
          the Black fraternity and sorority experience, and chapters at Virginia
          Tech would often perform right here in Dietrick Plaza.
        </p>
        <Carousel :images="stepping" />
        <p v-if="captions" class="content">
          In 1983, black Greek students held the first ever Overton R. Johnson
          Endowed Scholarship Step Competition. Each of these organizations
          participated in the stepping competition, which raised scholarship
          funds in honor of Overton Johnson, who became Virginia Tech’s first
          black professor in 1969.
        </p>
        <ImageComponent :image="overton" />
      </template>
    </AccordionSection>
  </Accordion>
</template>

<script>
import Accordion from "@/components/Accordion.vue";
import AccordionSection from "@/components/AccordionSection.vue";
import Carousel from "@/components/Carousel.vue";
import ImageComponent from "@/components/ImageComponent.vue";

export default {
  components: {
    Accordion,
    AccordionSection,
    Carousel,
    ImageComponent
  },
  props: {
    captions: {
      type: Boolean
    }
  },
  data() {
    return {
      apa1975AtPark: {
        name: "Alpha Phi Alpha, Jefferson National Park, 1975",
        path:
          "D2 Opening Photos/ALPHA PHI ALPHA, JEFFERSON NATIONAL PARK, 1975.jpg",
        caption: "Alpha Phi Alpha at Jefferson National Park in 1975."
      },
      bocGreek1990: {
        name: "BOC Greek 1990",
        path: "D2 Opening Photos/BOCGreek1990.jpg",
        caption: "Greek Organizations Together"
      },
      apa: [
        {
          name: "APA 1974",
          path: "Alpha Phi Alpha section/APA 1974.png",
          caption: "Alpha Phi Alpha in 1974."
        },
        {
          name: "APA 1975",
          path: "Alpha Phi Alpha section/APA 1975.png",
          caption: "Alpha Phi Alpha in 1975."
        },
        {
          name: "APA at Interfraternity Council Meeting",
          path: "Alpha Phi Alpha section/APA at IFC 1976.png",
          caption:
            "APA president is only Black person at Interfraternity Council Meeting, 1976."
        },
        {
          name: "APA 1978",
          path: "Alpha Phi Alpha section/APA 1978.png",
          caption: "Alpha Phi Alpha in 1978."
        },
        {
          name: "APA stepping outside Dietrick 1980",
          path: "Alpha Phi Alpha section/Stepping APA 1980.jpg",
          caption: "Alpha Phi Alpha stepping outside Dietrick 1980."
        },
        {
          name: "APA stepping outside Dietrick 1980 2",
          path: "Alpha Phi Alpha section/APA stepping 1980 2.png",
          caption: "Alpha Phi Alpha stepping outside Dietrick 1980 #2."
        },
        {
          name: "APA 1999",
          path: "Alpha Phi Alpha section/APA 1999.png",
          caption: "Apha Phi Alpha in 1999."
        }
      ],
      aka: [
        {
          name: "AKA 1975",
          path: "Alpha Kappa Alpha Section/AKA 1975.png",
          caption: "Alpha Kappa Alpha in 1975."
        },
        {
          name: "AKA 1976",
          path: "Alpha Kappa Alpha Section/AKA 1976.png",
          caption: "Alpha Kappa Alpha in 1976."
        },
        {
          name: "AKA 1981",
          path: "Alpha Kappa Alpha Section/AKA 1981.png",
          caption: "Alpha Kappa Alpha in 1981."
        },
        {
          name: "AKA 1982",
          path: "Alpha Kappa Alpha Section/AKA 1982.png",
          caption: "Alpha Kappa Alpha in 1982."
        },
        {
          name: "AKA 1995",
          path: "Alpha Kappa Alpha Section/AKA 1995.png",
          caption: "Alpha Kapp Alpha in 1995."
        },
        {
          name: "AKA 1997",
          path: "Alpha Kappa Alpha Section/AKA at MissEgyp 1997.png",
          caption: "Alpha Kapp Alpha in 1997."
        },
        {
          name: "AKA 2001",
          path: "Alpha Kappa Alpha Section/AKA 2001.jpg",
          caption: "Alpha Kapp Alpha in 2001."
        }
      ],
      dst: [
        {
          name: "DST 1986",
          path: "Delta Sigma Theta Section/DST1986.jpg",
          caption: "Delta Sigma Theta in 1986."
        },
        {
          name: "DST 1991",
          path: "Delta Sigma Theta Section/DST 1991.jpg",
          caption: "Delta Sigma Theta in 1991."
        },
        {
          name: "DST Stepping 2001",
          path: "Delta Sigma Theta Section/dst stepping 2001.png",
          caption: "Delta Sigma Theta Stepping in 2001."
        },
        {
          name: "DST 2001 Member",
          path: "Delta Sigma Theta Section/DST 2001 member.png",
          caption: "A member of DST in 2001."
        },
        {
          name: "DST 2003 Member",
          path: "Delta Sigma Theta Section/DST member 2003.png",
          caption: "A member of DST in 2003."
        },
        {
          name: "DST 2004",
          path: "Delta Sigma Theta Section/DST 2004.png",
          caption: "Delta Sigma Theta in 2004."
        }
      ],
      kap: {
        name: "KAP 1995",
        path: "Kappa Alpha Psi Section/Kappa Alpha Psi 1995.jpg",
        caption: "Kappa Alpha Psi in 1995."
      },
      opp: [
        {
          name: "OPP 1982",
          path: "Omega Psi Phi Section/OPP 1982.jpg",
          caption: "Omega Psi Phi in 1982."
        },
        {
          name: "OPP 1986",
          path: "Omega Psi Phi Section/OPP1986.png",
          caption: "Omega Psi Phi in 1986."
        },
        {
          name: "OPP Stepping 1989",
          path: "Omega Psi Phi Section/OPP stepping 1989.jpg",
          caption: "Omega Psi Phi members stepping, 1989."
        },
        {
          name: "OPP sisters stepping",
          path: "Omega Psi Phi Section/OPP sisters stepping 1989.png",
          caption: "Omega Psi Phi sisters stepping, 1989."
        },
        {
          name: "OPP Stepping 2003",
          path: "Omega Psi Phi Section/OPP2003.jpg",
          caption: "Omega Psi Phi in 2003."
        }
      ],
      pbs: [
        {
          name: "PBS 1994",
          path: "Phi Beta Sigma Section/Phi beta sigma 1994.jpg",
          caption: "Phi Beta Sigma in 1994."
        },
        {
          name: "PBS in front of BCC mural 1995",
          path: "Phi Beta Sigma Section/PhiBetaSig1995.jpg",
          caption: "Phi Beta Sigma in 1995."
        },
        {
          name: "PBS 2003",
          path: "Phi Beta Sigma Section/phibetasigma2003.jpg",
          caption: "Phi Beta Sigma in 2003."
        }
      ],
      zpb: [
        {
          name: "ZPB 1994",
          path: "Zeta Phi Beta Section/ZetaPhiBeta1994.jpg",
          caption: "Zeta Phi Beta in 1994."
        },
        {
          name: "ZPB 1995",
          path: "Zeta Phi Beta Section/ZetaPhiBeta1995.jpg",
          caption: "Zeta Phi Beta in 1995."
        }
      ],
      sgr: {
        name: "SGR 1986",
        path: "Sigma Gamma Rho Section/SigmaGammaRho1986.jpg",
        caption: "Sigma Gamma Rho in 1986."
      },
      stepping: [
        {
          name: "APA Stepping 1980",
          path: "Stepping-Overton Johnson Section/APA stepping 1980.png",
          caption: "Alpha Phi Alpha stepping, 1980."
        },
        {
          name: "APA Stepping 1980 2",
          path: "Stepping-Overton Johnson Section/Stepping APA 1980.jpg",
          caption: "Alpha Phi Alpha stepping, 1980 #2."
        },
        {
          name: "APA Stepping 1984",
          path: "Stepping-Overton Johnson Section/Stepping APA, 1984.png",
          caption: "Alpha Phi Alpha stepping, 1984."
        },
        {
          name: "OPP Stepping 1989",
          path: "Stepping-Overton Johnson Section/OPP stepping 1989.jpg",
          caption: "Omega Psi Phi stepping, 1989."
        },
        {
          name: "OPP Sisters Stepping 1989",
          path:
            "Stepping-Overton Johnson Section/OPP sisters stepping 1989.png",
          caption: "Omega Psi Phi sisters stepping, 1989."
        },
        {
          name: "Step Show 1995",
          path: "Stepping-Overton Johnson Section/stepshow1995.jpg",
          caption: "A step show in 1995."
        }
      ],
      overton: {
        name: "Overton Johnson",
        path: "Stepping-Overton Johnson Section/Overton Johnson.jpg",
        caption: "Overton Johnson"
      }
    };
  }
};
</script>
